import { Controller, useForm } from "react-hook-form";
import OrbInput from "../../../../shared/forms/orb-input";
import OrbButton from "../../../../shared/components/orb-button";
import { authConfig, passwordConfig } from "../../auth-config";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  passwordValidationSchema,
  verifyMailValidationSchema,
} from "../../../../shared/components/schema-validation/schema-validation";
import { passwordProps } from "../../auth-interface";
import { useTranslation } from "react-i18next";

const Password = (props: passwordProps) => {
  const { selectedDetails, save, setSelectedDetails,passwordLoading } = props;
  const { t } = useTranslation();
  const defaultValues = {
    ...(selectedDetails.id === authConfig.verify_email.id && { usr_email: "" }),
    ...(selectedDetails.id === authConfig.password.id && { usr_password: "" }),
    ...(selectedDetails.id === authConfig.password.id && {
      confirm_password: "",
    }),
  };
  const schemaMap: any = {
    [authConfig.verify_email.id]: verifyMailValidationSchema,
    [authConfig.password.id]: passwordValidationSchema,
  };
  const schemaValidation = schemaMap[selectedDetails.id];

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<any>({
    defaultValues: defaultValues,
    resolver: yupResolver(schemaValidation),
  });

  const onSubmit = (data: any) => {
    delete data.confirm_password;
    save(data, selectedDetails.id);
  };
  const handleSwitch = () => {
    setSelectedDetails(authConfig.login);
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        {passwordConfig(selectedDetails.id, authConfig.verify_email.id).map(
          (data: any) => {
            const error:any =errors?.[data.name]?.message
            return (
              <div className={data.style}>
                <Controller
                  name={data.name}
                  control={control}
                  render={({ field: { onChange, value } }) => {
                    return (
                      <OrbInput
                        type={data.type}
                        placeholder={t(data.placeholder)}
                        value={value}
                        onChange={onChange}
                        errorMessage={t(error) || ""}
                        label={t(data.label)}
                      />
                    );
                  }}
                />
              </div>
            );
          }
        )}

        <div className="pt-2 d-flex justify-content-between">
          <p className=" mohave sub-font m-1">
            {t("back_to")}{" "}
            <a className="pointer link" onClick={handleSwitch}>
              {t("log_in")}
            </a>
          </p>
          <OrbButton type={"submit"} label={t("submit")} iconName={"check"} loading={passwordLoading}  />
        </div>
      </form>
    </>
  );
};

export default Password;
